export default {
  SuIncrementList: {
    TitleList: 'Ghi tăng CCDC',
  },
  SuIncrementDetail: {
    Title: 'Phiếu ghi tăng CCDC',
    Text: {
      OtherInfo: 'Thông tin khác',
      GeneralInfo: 'Thông tin chung',
      Save: 'Cất (Ctrl + S)',
      Cancel: 'Hủy',
      Department: 'Phòng ban',
      DepartmentName: 'Tên phòng ban',
      RefDate: 'Ngày CT',
      RefNo: 'Số CT',
      PostedDate: 'Ngày HT',
      Description: 'Diễn giải',
      CTReference: 'CT tham chiếu',
    },
    TextTooltip: {
      RefDate: 'Ngày chứng từ',
      RefNo: 'Số chứng từ',
      PostedDate: 'Ngày hạch toán',
    },
    Warning: {
      MissCCDCInfo: 'Thiếu thông tin CCDC. Xin vui lòng kiểm tra lại.',
      MissSupplyPosted: 'Lỗi ghi chứng từ vào sổ vật tư: thiếu Vật tư.',
      InvalidAccount: 'Thông tin tài khoản hạch toán chưa hợp lệ. Xin vui lòng kiểm tra lại.',
      MissAmount: 'Thông tin chứng từ thiếu Số tiền tại dòng {0}.',
      MissDepartment: 'Bạn cần nhập phòng ban tại dòng {0}.',
    },
  },
};
